/* OrderExtra Create, Vue Component */
<template>
  <v-card v-if="entity && !loading" id="orderextra-create" class="entity-create">
      <v-card-title>Create Order Extra</v-card-title>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-alert
          v-if="serverErrorMessage"
          type="error"
        >
          {{ serverErrorMessage }}
        </v-alert>
      </v-card-text>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-row class="align-center pb-5">
        <v-col>
        <v-btn
          color="primary"
          class="me-3"
          @click="Save"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiContentSaveOutline  }}
          </v-icon>
          <span>Save</span>
        </v-btn>
        </v-col>
        <v-col class="text-right">
        <v-btn
          color="secondary"
          class="me-3"
          :to="{ name: 'orderextra-list' }"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiClose }}
          </v-icon>
          <span>Cancel</span>
        </v-btn>
        </v-col>
      </v-row>
      </v-card-text>

      <v-form ref="form">
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>

      <tr>
        <td>Name</td>
        <td><v-text-field
      label="Name"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Name').map(x => x.error)"
      v-model="entity.Name"
      :rules="[validators.required]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Price</td>
        <td><v-text-field
      label="Price"
      solo-inverted
			prefix="£"
			type="number"
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Price').map(x => x.error)"
      v-model="entity.Price"
      :rules="[validators.requiredNumber]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Example</td>
        <td><v-text-field
      label="Example"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Example').map(x => x.error)"
      v-model="entity.Example"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Additional Info</td>
        <td><v-textarea
      label="Additional Info"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Additional').map(x => x.error)"
      v-model="entity.Additional"
      :rules="[]"
    ></v-textarea>
</td>
      </tr>

      <tr>
        <td>Order</td>
        <td><v-text-field
      label="Order"
      solo-inverted
			type="number"
      flat
      :error-messages="serverErrors.filter(x => x.field === 'SortOrder').map(x => x.error)"
      v-model="entity.SortOrder"
      :rules="[validators.requiredInteger,validators.integerValidator]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Enabled</td>
        <td><v-checkbox v-model="entity.Enabled" :color="(entity.Enabled ? 'success' : 'secondary')"></v-checkbox></td>
      </tr>

      <tr>
        <td>Admin Only</td>
        <td><v-checkbox v-model="entity.AdminOnly" :color="(entity.AdminOnly ? 'warning' : 'secondary')"
          hint="Only the Admin Team can add this to an order (Book In / Quote). Customers can't choose it." persistent-hint></v-checkbox></td>
      </tr>


        </tbody>
      </v-simple-table>
      </v-form>

  </v-card>
</template>

<script>
import store from '@/store'
import { useRouter } from '@core/utils'
import * as Display from '@/datahelpers/displayTypes'
import * as FrameworkValidators from '@core/utils/validation'
import * as Validators from '@/datahelpers/validation'



import {
  mdiContentSaveOutline,
  mdiClose
} from '@mdi/js'
import { ref, watch, computed, expose } from '@vue/composition-api'

export default {
  components: {


  },
  setup() {

    const { route, router  } = useRouter();

    const entity = ref({
      SortOrder: 0
    });
    const loading = ref(false);
    const form = ref(null);
    const serverErrors = ref([]);
    const serverErrorMessage = ref(null);

    const Save = function(e) {

      serverErrorMessage.value = null;
      serverErrors.value = [];

      const valid = form.value.validate();

      if (!valid) {
        return;
      }

      loading.value = true;

      store
        .dispatch('app/createOrderExtra', {
          entity: entity.value
        })
        .then(response => {
          loading.value = false;
          router.push({ name: 'orderextra-view', params: { id: response.data.Id } });
        })
        .catch((error) => {
          loading.value = false;
          if (error.error) {
            if (error.message) serverErrorMessage.value = error.message;
            if (error.errors) serverErrors.value = error.errors
          } else {
            console.log(error);
          }
        });
    };

    const validators = {
      ...FrameworkValidators,
      ...Validators
    };

    return {
      form,
      Save,
      loading,
      entity,
      Display,
      icons: {
        mdiContentSaveOutline ,
        mdiClose
      },
      validators,
      serverErrorMessage,
      serverErrors
    };
  }
}
</script>

<style lang="scss" scoped>
.entity-create::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
  padding-right: 0;
}
.entity-create::v-deep .v-data-table th:last-child {
  width: 66%;
}
.entity-create::v-deep  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: transparent;
}
.entity-create::v-deep .v-input:not(.error--text) .v-messages {
  min-height: unset;
}
.entity-create::v-deep .v-input .v-messages.error--text {
  margin-bottom: 8px;
}
.entity-create::v-deep .v-input:not(.error--text) .v-text-field__details {
  min-height: unset;
  margin-bottom: 0;
}
.entity-create::v-deep .v-input:not(.error--text) .v-input__slot {
  margin: 0;
  border-radius: 0;
}
.entity-create::v-deep .v-input--selection-controls {
  margin: 10px;
}
</style>

